{
  "user-profile": {
    "buttons": {
      "confirm-email": "E-Mail bestätigen",
      "confirm-phone-nr": "Telefonnummer bestätigen",
      "update": "Aktualisieren",
      "update-password": "Passwort aktualisieren",
      "update-phone-nr": "Telefonnummer aktualisieren"
    },
    "text": {
      "communication": "Kommunikation",
      "communication-hint": "Die meisten Salons verwenden E-Mails für die Kommunikation (bspw. für Terminbestätigung), aber einige bieten auch die Option, per SMS in Kontakt zu treten. Bevorzugen Sie SMS in diesen Fällen?",
      "confirm-email": "Bitte bestätigen Sie Ihre E-Mail",
      "confirm-phone-nr": "Bitte bestätigen Sie Ihre Telefonnummer",
      "contact-data": "Kontaktangaben",
      "in-second": "in {{seconds}} s",
      "password": "Passwort",
      "personal-data": "Persönliche Angaben",
      "pin-code": "PIN code",
      "pin-code-hint": "Bitte stellen Sie alle {{ numberOfPinDigit }} PIN-Ziffern ein, zu aktualisierenden. Diese PIN wird nur zum Anmelden bei Beauty Checkin und Beauty Checkout verwendet.",
      "update-password-by-email": "Der PIN-Code wird Ihnen per E-Mail zugesandt. Sie benötigen diesen PIN-Code, um Ihr neues Passwort zu bestätigen.",
      "update-password-by-sms": "Der PIN-Code wird Ihnen per SMS zugesandt. Sie benötigen diesen PIN-Code, um Ihr neues Passwort zu bestätigen.",
      "update-success": "Erfolgreich aktualisiert!",
      "via-email": "Nein",
      "via-sms": "Ja"
    }
  }
}
